let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aQwae")).then(() => parcelRequire('4w9rV'));